import initI18n from './i18n';
import { registerSpawnToolCallEnrichers } from './registerSpawnToolCallEnrichers';

export default function init(): void {
  initI18n();
  registerSpawnToolCallEnrichers();
}
